export const wrapCurrencyFactory = (currencyCode: string) => (
  n: number
): string => {
  if (['SEK', 'NOK', 'DKK', 'ISK'].includes(currencyCode)) {
    return `${n} kr`
  }

  switch (currencyCode) {
    case 'EUR':
      return `&euro;${n}`
    case 'CHF':
      return `CHF ${n}`
    case 'USD':
    case 'CAD':
    case 'MXN':
    case 'ARS':
      return `$${n}`
    case 'TRY':
      return `₺${n}`
    case 'INR':
      return `₹${n}`
    case 'JPY':
      return `¥${n}`
    case 'PLN':
      return `${n}zł`
    default:
      return `&pound;${n}`
  }
}
